import { useLayoutEffect, useMemo, useRef, useState } from "react";
import { Flex, Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";
import { MenuCTA } from "components/MenuCTA/";
export const DEFAULT_CTA_BUTTONS_WIDTH = 32;

export const ItemCardHeader = ({
  title,
  onEditClick,
  recordId,
  resource,
  invalidationResource,
}: {
  title: string;
  onEditClick: () => void;
  recordId: string;
  resource: string;
  invalidationResource?: string;
}) => {
  const { isMobile } = useAntTheme();
  const buttonRef = useRef<HTMLDivElement>(null);
  const [buttonWidth, setButtonWidth] = useState<number>(0);

  useLayoutEffect(() => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, []);

  const headerPaddingRight = useMemo(() => {
    return isMobile ? 0 : Math.max(buttonWidth, DEFAULT_CTA_BUTTONS_WIDTH) + 10;
  }, [buttonWidth, isMobile]);

  return (
    <Flex
      justify="space-between"
      align={isMobile ? "end" : "center"}
      style={{ position: "relative", height: isMobile ? 60 : 50 }}
      gap={10}
    >
      <Typography.Text
        style={{
          fontSize: 18,
          fontWeight: 500,
          letterSpacing: -1.2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          paddingRight: headerPaddingRight,
          flex: 1,
        }}
      >
        {title}
      </Typography.Text>
      <div
        ref={buttonRef}
        style={{
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          right: 0,
        }}
      >
        <MenuCTA
          onEditClick={onEditClick}
          recordId={recordId}
          resource={resource}
          invalidationResource={invalidationResource}
        />
      </div>
    </Flex>
  );
};
